export default {
  getHead: () => {
    return [{ name: '사업장명' }, { name: '안전관리자' }, { name: '보건관리자' }, { name: '산업보건의' }, { name: '부서명' }, { name: '작성자' }, { name: '작성일' }, ]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
      case 0: return func.getContent(value).stdInfo.field_name // 사업장명
      case 1: return func.getContent(value).admin1 // 안전관리자
      case 2: return func.getContent(value).admin2 // 보건관리자
      case 3: return func.getContent(value).admin3 // 산업보건의
      case 4: return func.getContent(value).stdInfo.section // 부서명
      case 5: return func.getContent(value).stdInfo.writer_name // 작성자
      case 6: return func.getCreatedDate(value.created_at) // 작성일
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.created_at) {
      nav.dateTarget = 'created_at'
      nav.dateBegin = 'nav.value.created_at.sDate'
      nav.dateEnd = 'nav.value.created_at.eDate'
    }
    return { searchType: nav.value.searchType, searchKeyword: nav.value.searchKeyword }
  },
  getSearchKeyword: (nav) => {
    const returnData = []

    switch (nav.value.searchType) {
    case '사업장명': returnData.push('content$body.stdInfo.field_name*%[:default_skw]%'); break
    case "안전관리자": returnData.push('content$body.admin1*%[:default_skw]%'); break
    case "보건관리자": returnData.push('content$body.admin2*%[:default_skw]%'); break
    case "산업보건의": returnData.push('content$body.admin3*%[:default_skw]%'); break
    case '부서명': returnData.push('content$body.stdInfo.section*%[:default_skw]%'); break
    case '작성자': returnData.push('content$body.stdInfo.writer_name*%[:default_skw]%'); break
    }

    return returnData
  },
}
